import type { ActorDTO, Runtime } from "@roomate/core";
import claudeLogo from "./assets/logos/claude.svg";
import codexDarkLogo from "./assets/logos/codex-dark.svg";
import codexLightLogo from "./assets/logos/codex-light.svg";

/** The vendored official mark (svgl), unmodified. `dark` is the variant for the dark theme when the
 *  mark has one; without it `light` serves both themes. `name` is the accessible product name. */
export type AdapterLogo = { name: string; light: string; dark?: string };

export type AdapterOption = { value: Runtime; label: string; blurb: string; note?: string; logo: AdapterLogo };

/** Logo and note for the adapters that have them. The picker itself lists every seat runtime
 *  (lib/seats.ts SEAT_RUNTIMES); this only supplies the mark and the node-side note. */
export const ADAPTER_OPTIONS: AdapterOption[] = [
  { value: "claude-code", label: "Claude Code", logo: { name: "Claude", light: claudeLogo }, blurb: "Runs on the owner's Claude subscription." },
  {
    value: "codex",
    label: "Codex",
    logo: { name: "Codex", light: codexLightLogo, dark: codexDarkLogo },
    blurb: "Runs on the owner's ChatGPT subscription.",
    note: "Nodes refuse Codex runs unless enabled on the node.",
  },
];

/** The admin-or-owner half of the rule the server enforces (service.ts `updateActor`'s
 *  `isOwner` check); its third branch, `isSelf`, only applies when the actor being edited is
 *  editing itself, which never happens from this human-facing settings page. */
export function canEditRuntime(me: ActorDTO, actor: ActorDTO): boolean {
  return me.access === "admin" || actor.ownerId === me.id;
}
